var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50781 5.4635V4C6.50781 3.60218 6.66585 3.22064 6.94715 2.93934C7.22846 2.65804 7.60999 2.5 8.00781 2.5H21.0078C21.4056 2.5 21.7872 2.65804 22.0685 2.93934C22.3498 3.22064 22.5078 3.60218 22.5078 4V17C22.5078 17.3978 22.3498 17.7794 22.0685 18.0607C21.7872 18.342 21.4056 18.5 21.0078 18.5H19.5163",
    stroke: "#F6EFE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0078 5.5H4.00781C3.17939 5.5 2.50781 6.17157 2.50781 7V21C2.50781 21.8284 3.17939 22.5 4.00781 22.5H18.0078C18.8362 22.5 19.5078 21.8284 19.5078 21V7C19.5078 6.17157 18.8362 5.5 18.0078 5.5Z",
    stroke: "#F6EFE9",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72778 12.0546L12.3738 9.29961C13.0993 8.57411 14.2923 8.58961 15.0378 9.33561C15.7833 10.0811 15.7993 11.2741 15.0738 11.9996L14.1188 13.0111M7.24078 14.8731C6.98578 15.1281 6.45828 15.6381 6.45828 15.6381C5.73228 16.3636 5.71228 17.6571 6.45828 18.4031C7.20328 19.1481 8.39628 19.1646 9.12228 18.4386L11.7043 16.0946",
    stroke: "#F6EFE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.836 14.664C9.50386 14.334 9.3029 13.8946 9.2705 13.4275C9.25135 13.1655 9.28876 12.9024 9.38021 12.6561C9.47165 12.4098 9.61499 12.186 9.8005 12M11.665 13.4305C12.4105 14.176 12.4265 15.369 11.701 16.095",
    stroke: "#F6EFE9",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.b11d3a4cc6dc64d2bcefdaf4d93118c9.svg";
export { ForwardRef as ReactComponent };